import apiClient from "../../../common/api/apiClient";
import { ResetPasswordDto } from "./resetPassword.dtos";
import { showNotification } from "../../../common/actionCreators/dispatchNotification";

// endpoints
const resetPasswordUrl = "/account/resetPassword";

export const resetPasswordApi = async (request: ResetPasswordDto) => {
  return await apiClient
    .post(resetPasswordUrl, request)
    .then(() => {
      showNotification("Your password has been reset.", "success");
      return true;
    })
    .catch(err => {
      console.log(err)
      showNotification(err.response.data, "error");
      throw err;
    });
};
